import script from "./TeacherPage.vue?vue&type=script&setup=true&lang=js"
export * from "./TeacherPage.vue?vue&type=script&setup=true&lang=js"

import "./TeacherPage.vue?vue&type=style&index=0&id=a32be750&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a32be750"]])

export default __exports__